import React from 'react';
import styled from './styled';
import Box from './box';
import { Theme } from './theme';
import convertCssUnit from './convert-css-unit';
import convertShorthand from './convert-shorthand';

const StyledLoader = styled(Box)`
  animation: spin 0.5s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

interface Props {
  size?: number;
  color?: string;
  backgroundColor?: string;
  borderRadius?: number | string;
  m?: number | string;
  theme?: Theme;
}

export default function Loader({
  size = 20,
  color = 'action',
  backgroundColor = 'separator',
  borderRadius = 10,
  m = '0 1rem',
  ...rest
}: Props) {
  return (
    <StyledLoader
      borderWidth={convertCssUnit(size / 10)}
      borderColor={backgroundColor}
      borderTopColor={color}
      width={convertCssUnit(`${size / 16}rem`)}
      height={convertCssUnit(`${size / 16}rem`)}
      borderRadius={convertCssUnit(borderRadius)}
      {...convertShorthand('margin', m)}
      {...rest}
    />
  );
}
